const CSTypes = {
  FETCH_RATES_AVRAGE_START: 'FETCH_RATES_AVRAGE_START',
  FETCH_CS_PERCENT_START: 'FETCH_CS_PERCENT_START',
  FETCH_RATES_COUNT_START: 'FETCH_RATES_COUNT_START',

  FETCH_HAPPY_CUSTOMERS_START: 'FETCH_HAPPY_CUSTOMERS_START',
  FETCH_ANGRY_CUSTOMERS_START: 'FETCH_ANGRY_CUSTOMERS_START',

  SET_RATES_AVRAGE: 'SET_RATES_AVRAGE',
  SET_CS_PERCENT: 'SET_CS_PERCENT',
  SET_RATES_COUNT: 'SET_RATES_COUNT',

  SET_HAPPY_CUSTOMERS: 'SET_HAPPY_CUSTOMERS',
  SET_ANGRY_CUSTOMERS: 'SET_ANGRY_CUSTOMERS',

  LOADING_RATES_AVRAGE: 'LOADING_RATES_AVRAGE',
  LOADING_CS_PERCENT: 'LOADING_CS_PERCENT',
  LOADING_RATES_COUNT: 'LOADING_RATES_COUNT',

  LOADING_HAPPY_CUSTOMERS: 'LOADING_HAPPY_CUSTOMERS',
  LOADING_ANGRY_CUSTOMERS: 'LOADING_ANGRY_CUSTOMERS',

  FETCH_PLATFORMS_STATS_DATA: 'FETCH_PLATFORMS_STATS_DATA',
  SET_PLATFORMS_STATS_DATA: 'SET_PLATFORMS_STATS_DATA',
  SET_LOADING_PLATFORMS_STATS: 'SET_LOADING_PLATFORMS_STATS',

  FETCH_USERS_STATS_DATA: 'FETCH_USERS_STATS_DATA',
  SET_USERS_STATS_DATA: 'SET_USERS_STATS_DATA',
  SET_LOADING_USERS_STATS: 'SET_LOADING_USERS_STATS',
};

export default CSTypes;
